"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _errors = _interopRequireDefault(require("../errors"));
/**
 * This validation check for empty fields
 * @param  {string} value - name of the field
 * @param  {string} field - Data Model used for validation
 */
var required = function required(val, field) {
  return !val && _errors["default"][field] ? _errors["default"][field].required : false;
};
var _default = required;
exports["default"] = _default;
